/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PortfolioUserPerformanceQueryVariables = {|
  weeks?: ?number,
  month?: ?number,
  days?: ?number,
  all?: ?boolean,
|};
export type PortfolioUserPerformanceQueryResponse = {|
  +userPerformanceAnalysis: ?$ReadOnlyArray<?{|
    +marketCurrentTotal: ?any,
    +created: ?any,
  |}>
|};
export type PortfolioUserPerformanceQuery = {|
  variables: PortfolioUserPerformanceQueryVariables,
  response: PortfolioUserPerformanceQueryResponse,
|};
*/


/*
query PortfolioUserPerformanceQuery(
  $weeks: Int
  $month: Int
  $days: Int
  $all: Boolean
) {
  userPerformanceAnalysis(weeks: $weeks, month: $month, days: $days, all: $all) {
    marketCurrentTotal
    created
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "all"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "days"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "weeks"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "all",
        "variableName": "all"
      },
      {
        "kind": "Variable",
        "name": "days",
        "variableName": "days"
      },
      {
        "kind": "Variable",
        "name": "month",
        "variableName": "month"
      },
      {
        "kind": "Variable",
        "name": "weeks",
        "variableName": "weeks"
      }
    ],
    "concreteType": "UserPerformanceNode",
    "kind": "LinkedField",
    "name": "userPerformanceAnalysis",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketCurrentTotal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "created",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioUserPerformanceQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PortfolioUserPerformanceQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "9d1dbfb8549dd94d48f4e4d36eb4cee2",
    "id": null,
    "metadata": {},
    "name": "PortfolioUserPerformanceQuery",
    "operationKind": "query",
    "text": "query PortfolioUserPerformanceQuery(\n  $weeks: Int\n  $month: Int\n  $days: Int\n  $all: Boolean\n) {\n  userPerformanceAnalysis(weeks: $weeks, month: $month, days: $days, all: $all) {\n    marketCurrentTotal\n    created\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '45080f68fe7e1042ca0e5f9cc6ed8df7';

module.exports = node;
